import { DashboardModalStatePresenter } from '@/presentation/presenters/dashboard/dashboardModalStatePresenter'
import { DashboardModalStateViewModel } from '@/presentation/viewmodels/dashboard/dashboardModalStateViewModel'

export function useDashboardModalStatePresenter(
  presenter: DashboardModalStatePresenter = new DashboardModalStatePresenter(new DashboardModalStateViewModel())
) {
  return {
    isAddingDashboardUser: presenter.isAddingDashboardUser,
    dashboardUserList: presenter.dashboardUserList,
    dashboardProgramLanguage: presenter.dashboardProgramLanguage,
    initialDashboardUser: presenter.initialDashboardUser,
    courseSerial: presenter.courseSerial,
    tabState: presenter.tabState,
    isLoading: presenter.isLoading,
    error: presenter.error,
    addDashboardUser: presenter.addDashboardUser.bind(presenter),
    reloadCharts: presenter.reloadCharts.bind(presenter),
    reloadRadarCharts: presenter.reloadRadarCharts.bind(presenter),
    clearTargetUsers: presenter.clearTargetUsers.bind(presenter),
    isExistUser: presenter.isExistUser.bind(presenter),
    removeDashboardUserList: presenter.removeDashboardUserList.bind(presenter),
    removeTargetUsers: presenter.removeTargetUsers.bind(presenter),
    setInitialDashboardUser: presenter.setInitialDashboardUser.bind(presenter),
    setDashboardProgramLanguage: presenter.setDashboardProgramLanguage.bind(presenter),
    setCourseSerial: presenter.setCourseSerial.bind(presenter),
    setTabState: presenter.setTabState.bind(presenter)
  }
}
